import {
  IAdminPayload,
  IUpdateAdminPayload,
  IUpdateProfilePayload,
} from '@/types/payload';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getAdminList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const getAdminSummary = async () => {
  return serviceHelper(http.get(`/admin/summary`), false);
};

export const getRoleDropdown = async () => {
  return serviceHelper(http.get(`/admin/role/dropdown`), false);
};

export const createAdmin = async (data: IAdminPayload) => {
  return serviceHelper(http.post('/admin', data));
};

export const updateAdmin = async (id: string, data: IUpdateAdminPayload) => {
  return serviceHelper(http.patch(`/admin/${id}`, data), true);
};

export const getAdminById = async (id: string | number) => {
  return serviceHelper(http.get(`/admin/${id}`), false);
};

export const getAdminProfile = async () => {
  return serviceHelper(http.get('/admin/profile'), false);
};

export const updateAdminProfile = async (data: IUpdateProfilePayload) => {
  return serviceHelper(http.patch('/admin', data), true);
};

export const uploadAdminImage = async (data: FormData) => {
  return serviceHelper(
    http.post('/upload/admin/image', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
    false
  );
};
